module.exports = __webpack_public_path__ + "static/media/71.c6a3cd14.png";